// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bah1h6o{justify-content:center}
._1e0c1txw{display:flex}
._1ul98pqr{min-width:2.5rem}
._o5721q9c{white-space:nowrap}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/calendar/dist/esm/internal/components/week-header.compiled.css"],"names":[],"mappings":"AAAA,WAAW,sBAAsB;AACjC,WAAW,YAAY;AACvB,WAAW,gBAAgB;AAC3B,WAAW,kBAAkB","sourcesContent":["._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._1ul98pqr{min-width:2.5rem}\n._o5721q9c{white-space:nowrap}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
